<template>
  <base-dialog v-model="isVisibleTicketTemplate">
    <dialog-template>

      <div
        slot="title"
        v-text="$t('bill.ticket.template.edit.title')"
      />

      <div slot="content" v-m-t="1" v-m-b="1">
        <div class="textarea-composite-container">
          <input-textarea
            :value="attachment.name"
            input-id="tariff-file-input"
            :input-name="$t('bill.ticket.template.field.label')"
            :input-title="$t('bill.ticket.template.field.label')"
            :input-placeholder="$t('bill.ticket.template.field.placeholder')"
            :show-counter="false"
            :max-length="255"
            :required="false"
            :rows="1"
            composite
            readonly
            @click="handleAttachment"
          >
            <help-link slot="link" source="https://tilda.cc/page/?pageid=27310997" />
          </input-textarea>
          <attachment-image
            ref="attachment"
            :link="attachment.link"
            input-id="tariff.file"
            type="secondary"
            composite
            composite-textarea
            upload-type="ticket"
            accept="application/vnd.ms-word.document.macroEnabled.12, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.wordprocessingml.template, application/vnd.ms-word.template.macroEnabled.12"
            @loading="onImageLoading"
            @uploaded="data => attachment.setData(data)"
            @reset="attachment.reset()"
          />
        </div>
      </div>

      <simple-button
        slot="submit"
        variant="primary"
        :disabled="submittingDisabled"
        @click="handleSavingTemplate"
      >
        {{ $t('common.apply') }}
      </simple-button>
      <simple-button
        slot="cancel"
        variant="transparent"
        @click="handleClose"
      >
        {{ $t('common.cancel') }}
      </simple-button>

    </dialog-template>
  </base-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';

import attachmentMixin from 'lib/mixins/attachmentMixin';

import BaseDialog from 'molecules/base/Dialog';
import SimpleButton from 'molecules/common/SimpleButton';
import DialogTemplate from 'templates/DialogTemplate';

import InputTextarea from '@/components/inputElements/InputTextarea';
import AttachmentImage from 'modules/AttachmentImage';

import HelpLink from 'molecules/HelpLink';

import { EVENT_BUS } from '@/eventBus';

export default {
  name: 'TicketTemplateDialog',
  mixins: [
    attachmentMixin,
  ],
  components: {
    BaseDialog,
    SimpleButton,
    DialogTemplate,
    InputTextarea,
    AttachmentImage,
    HelpLink,
  },
  created() {
    EVENT_BUS.$on('EVENT_EDIT_TICKET_TEMPLATE', this.showDialog);
  },
  beforeDestroy() {
    EVENT_BUS.$off('EVENT_EDIT_TICKET_TEMPLATE', this.showDialog);
  },
  data() {
    return {
      isVisibleTicketTemplate: false,
    };
  },
  computed: {
    template() {
      if (this.$validate.isNotObject(this.editableTicket)) {
        return null;
      }

      const { arrangement } = this.editableTicket;

      return arrangement.template;
    },
    getPayload() {
      if (this.$validate.isNotObject(this.editableTicket)) {
        return null;
      }

      const { id: editableTicketId } = this.editableTicket;
      const { billTariffs } = this.SELECTED_TRANSACTION;

      const updatedBillTariffs = billTariffs.map(tariff => {
        const isCurrent = editableTicketId === tariff.id;

        return {
          ...tariff,
          arrangement: {
            ...tariff.arrangement,
            template: isCurrent ? this.attachment.getData() : tariff.arrangement.template,
          },
        };
      });

      return {
        billTariffs: updatedBillTariffs,
        publicId: this.SELECTED_TRANSACTION.public_id,
      };
    },
    ...mapState(['SELECTED_TRANSACTION']),
    ...mapGetters('ticket', ['editableTicket']),
  },
  watch: {
    isVisibleTicketTemplate: {
      handler(val) {
        if (!val) {
          this.attachment?.reset();
        }
      },
    },
  },
  methods: {
    showDialog() {
      if (this.$validate.isNotNull(this.template)) {
        this.attachment.setData(this.template);
      }

      this.isVisibleTicketTemplate = true;
    },
    handleClose() {
      this.isVisibleTicketTemplate = false;
    },
    async handleSavingTemplate() {
      this.isVisibleTicketTemplate = false;

      try {
        const { data } = await this.saveEditedTicket(this.getPayload);
        this.CHANGE_SELECTED_TRANSACTION_BILL_TARIFFS(data.billTariffs);
        this.attachment.reset();

        this.$alert({
          type: 'success',
          text: 'сhanges.saved',
        });
      } catch (error) {
        console.log(error);

        this.$alert({
          type: 'warning',
          text: 'problems.on.server',
        });
      }
    },
    handleAttachment() {
      this.$refs.attachment.$el.querySelectorAll('[type="file"]')[0].click();
    },
    ...mapActions('ticket', ['saveEditedTicket']),
    ...mapMutations(['CHANGE_SELECTED_TRANSACTION_BILL_TARIFFS']),
  },
};
</script>

<style lang="sass" scoped>
  .textarea-composite-container
    position: relative
    display: flex
    align-items: center

    .textarea
      margin: 0

      a
        height: auto
        margin: 0
        padding: 0
        align-self: auto
        text-decoration: none
        position: absolute
        right: 80px

        &:after
          content: none
</style>
